{
  "Email": "Email",
  "Email is Required.": "Email is Required.",
  "Please enter a valid email": "Please enter a valid email",
  "Password": "Password",
  "Password is Required.": "Password is Required.",
  "Password should be minimum of 8 characters.": "Password should be minimum of 8 characters.",
  "Password should be maximum of 15 characters.": "Password should be maximum of 15 characters.",
  "Please enter valid password.": "Please enter valid password",
  "Remember me": "Remember me",
  "Forgot password?": "Forgot password?",
  "Login": "Login",
  "Forgot Password": "Forgot Password",
  "We will send you link to reset your password": "We will send you link to reset your password",
  "Please enter your registered email below": "Please enter your registered email below",
  "The reset password link has been sent to your registered mail.": "The reset password link has been sent to your registered mail.",
  "Continue": "Continue",
  "Set New Password": "Set New Password",
  "Password and confirm password do not match": "Password and confirm password do not match",
  "Change Password": "Change Password",
  "New Password": "New Password",
  "Confirm Password": "Confirm Password",
  "Please enter your new password and confirm password.": "Please enter your new password and confirm password.",
  "Logout": "Logout",
  "Add Agent": "Add Agent",
  "Add New Agent": "Add New Agent",
  "Edit Agent": "Edit Agent",
  "List": "List",
  "Admin List": "Admin List",
  "Patient List": "Patient List",
  "Doctor List": "Doctor List",
  "Agent List": "Agent List",
  "Organization List": "Organization List",
  "All Consults List": "All Consults List",
  "TC & PP": "TC & PP",
  "Save": "Save",
  "Add New Member": "Add New Member",
  "Download Report": "Download Report",
  "First Name": "First Name",
  "Last Name": "Last Name",
  "Gender": "Gender",
  "Action": "Action",
  "Specialist Role": "Specialist Role",
  "Role of Specialist": "Role of Specialist",
  "Organization/Insurance Name": "Organization/Insurance Name",
  "Subsidiary detail": "Subsidiary detail",
  "Add Doctor": "Add Doctor",
  "First Name is Required.": "First Name is Required.",
  "Last Name is Required.": "Last Name is Required.",
  "Gender is Required.": "Gender is Required.",
  "Do you require medical specialties":"Do you require medical specialties",
  "Add": "Add",
  "Edit Doctor": "Edit Doctor",
  "Date of Birth": "Date of Birth",
  "Identification Number": "Identification Number",
  "Speciality": "Speciality",
  "Other Speciality": "Other Speciality",
  "Sub-Speciality": "Sub-Speciality",
  "Other Sub-Speciality": "Other Sub-Speciality",
  "MPPS Number": "MPPS Number",
  "CM Number": "CM Number",
  "Phone Number": "Phone Number",
  "Status": "Status",
  "Recording": "Recording",
  "Delete": "Delete",
  "Add New Organization": "Add New Organization",
  "Organization": "Organization",
  "Insurance": "Insurance",
  "Country Code": "Country Code",
  "Add New": "Add New",
  "Organization Name": "Organization Name",
  "Organization/Insurance Name is Required.": "Organization/Insurance Name is Required.",
  "Organization/Insurance Address": "Organization/Insurance address",
  "Organization/Insurance Logo": "Organization/Insurance logo",
  "Identification Number is Required.": "Identification Number is Required.",
  "Country Code is Required": "Country Code is Required",
  "Phone Number is Required.": "Phone Number is Required.",
  "Waiting Room is Required.": "Waiting Room is Required.",
  "Organization Name is Required.": "Organization/Insurance Name is Required.",
  "Add New Doctor": "Add New Doctor",
  "Not verified": "Not verified",
  "Activate": "Activate",
  "Deactivate": "Deactivate",
  "Are you sure you want to delete this user?": "Are you sure you want to delete this user?",
  "Cancel": "Cancel",
  "Yes": "Yes",
  "Are you sure you want to change the status of this user?": "Are you sure you want to change the status of this user?",
  "Old Password": "Old Password",
  "Old Password is Required.": "Old Password is Required.",
  "Confirm Password is Required.": "Confirm Password is Required.",
  "Other Sub-Speciality Name is Required.": "Other Sub-Speciality Name is Required.",
  "Other Speciality Name is Required": "Other Speciality Name is Required",
  "Please enter registered email": "Please enter registered email",
  "The old password doesn't match": "The old password doesn't match",
  "Members": "Members",
  "Password changed successfully": "Password changed successfully",
  "Active": "Active",
  "Role": "Role",
  "Last Active Date": "Last Active Date",
  "Admin Type": "Admin Type",
  "Add Member": "Add Member",
  "Edit Member": "Edit Member",
  "Edit Pacient": "Edit Pacient",
  "Membership Type": "Membership Type",
  "Venezuelan ID is Required.": "Venezuelan ID is Required.",
  "Country Code is Required.": "Country Code is Required.",
  "Phone Number is not Valid.": "Phone Number is not Valid.",
  "Country Code is not valid.": "Country Code is not valid.",
  "Chief Complaint": "Chief Complaint",
  "type": "Type",
  "Total number of patients": "Total number of patients",
  "Total number Successful consults": "Total number Successful consults",
  "Total number New consults": "Total number New consults",
  "Total number Follow up consults": "Total number Follow up consults",
  "Today": "Today",
  "This Week": "This Week",
  "This Month": "This Month",
  "This Year": "This Year",
  "Activity Log": "Activity Log",
  "Admin": "Admin",
  "Doctors": "Doctors",
  "Patients": "Patients",
  "Insurance providers": "Insurance providers",
  "Date Of Consult": "Date Of Consult",
  "Last Activity Date": "Last Activity Date",
  "Activity": "Activity",
  "Terms and condions & Privacy Policy": "Terms and condions & Privacy Policy",
  "Terms and condions": "Terms and condions",
  "Privacy Policy": "Privacy Policy",
  "Attachment": "Attachment",
  "View More": "View More",
  "Mode of Communication": "Mode of Communication",
  "Height": "Height",
  "Weight": "Weight",
  "BMI": "BMI",
  "Age": "Age",
  "Back to Home": "Back to Home",
  "Male": "Male",
  "Female": "Female",
  "Others": "Others",
  "Visit History": "Visit History",
  "Medical History": "Medical History",
  "Following":"Following",
  "Edit": "Edit",
  "Update": "Update",
  "Past Medical History": "Past Medical History",
  "Childhood Illnesses": "Childhood Illnesses",
  "Other Childillness": "Other Childillness",
  "Medical Conditions": "Medical Conditions",
  "Other Medical Condition": "Other Medical Condition",
  "Surgery": "Surgery",
  "Date": "Date",
  "Lifestyle information": "Lifestyle information",
  "Smoking Habit": "Smoking Habit",
  "Drinking Habit": "Drinking Habit",
  "Family history": "Family history",
  "Father": "Father",
  "Other Medical History of Father": "Other Medical History of Father",
  "Mother": "Mother",
  "Other Medical History of Mother": "Other Medical History of Mother",
  "Brother": "Brother",
  "Other Medical History of Brother": "Other Medical History of Brother",
  "Sister": "Sister",
  "Other Medical History of Sister": "Other Medical History of Sister",
  "Son": "Son",
  "Other Medical History of Son": "Other Medical History of Son",
  "Daughter": "Daughter",
  "Other Medical History of Daughter": "Other Medical History of Daughter",
  "Select your option": "Select your option",
  "Currently Taking": "Currently Taking",
  "Not Taking": "Not Taking",
  "Indications": "Indications",
  "Notes": "Notes",
  "Choose a tags": "Choose a tags",
  "Follow up": "Follow up",
  "Is this Test call?": " Is this Test call?",
  "Reason for visit": "Reason for visit",
  "Pregnancy status": "Pregnancy status",
  "No": "No",
  "Not sure": "Not sure",
  "Photos": "Photos",
  "No Photos Available": "No Photos Available",
  "History of present illnesses": "History of present illnesses",
  "Enter Text..": "Enter Text..",
  "Review Of System": "Review Of System",
  "Problem": "Problem",
  "Tell What..": "Tell What..",
  "Vital signs": "Vital signs",
  "mmHg": "mmHg",
  "BPSystolic": "BPSystolic",
  "BPDiastolic": "BPDiastolic",
  "bpm": "bpm",
  "HeartRate": "HeartRate",
  "Respiratory": "Respiratory",
  "`C": "`C",
  "Temperature": "Temperature",
  "Medical Information": "Medical Information",
  "Paraclinics": "Paraclinics",
  "Differential Diagnosis": "Differential Diagnosis",
  "Diagnosis": "Diagnosis",
  "Plan": "Plan",
  "Plan is Required.": "Plan is Required.",
  "Doctor Notes": "Doctor Notes",
  "Paraclinical Prescription": "Paraclinical Prescription",
  "Title": "Title",
  "Description": "Description",
  "Medical Prescription": "Medical Prescription",
  "Medication": "Medication",
  "Dosage": "Dosage",
  "international unit (s)": "international unit (s)",
  "Route (s)": "Route (s)",
  "Frequency": "Frequency",
  "hours": "hours",
  "Duration": "Duration",
  "Alternative": "Alternative",
  "Follow up Information": "Follow up Information",
  "Subjective": "Subjective",
  "Objective": "Objective",
  "Assessment": "Assessment",
  "Logs": "Logs",
  "Search": "Search",
  "mm/dd/yyyy hh:mm": "mm/dd/yyyy hh:mm",
  "mm/dd/yyyy": "mm/dd/yyyy",
  "Today Patients": "Today Patients",
  "Primary Calls": "Primary Calls",
  "Wait Time": "Wait Time",
  "Follow up calls": "Follow up calls",
  "In Consult": "In Consult",
  "Completed": "Completed",
  "Queue Status": "Queue Status",
  "Average Consultation Length": "Average Consultation Length",
  "Average Wait Time": "Average Wait Time",
  "Time to Completed": "Time to Completed",
  "Doctors Online": "Doctors Online",
  "HolaDoc Doctors": "HolaDoc Doctors",
  "Change": "Change",
  "Type of medical specialty":"Type of medical specialty",
  "Documents has been updated successfully": "Documents has been updated successfully",
  "visit history  updated Successfully": "visit history  updated Successfully",
  "The user details has been updated successfully": "The user details has been updated successfully",
  "The user details has been added successfully": "The user details has been added successfully",
  "The user details has been deleted successfully": "The user details has been deleted successfully",
  "Password has been changed successfully": "Password has been changed successfully",
  "The user status has been changed successfully": "The user status has been changed successfully",
  "The user has been  download the report successfully": "The user has been  download the report successfully",
  "Attachment has been Updated Successfully": "Attachment has been Updated Successfully",
  "Medical History Updated Successfully": "Medical History Updated Successfully",
  "Terms Condition has been added successfully": "Terms Condition has been added successfully",
  "Privacy Policy has been added successfully": "Privacy Policy has been added successfully",
  "Medication status has been changed  to deleted Successfully": "Medication status has been changed  to deleted Successfully",
  "Medication status has been changed  to completed  Successfully": "Medication status has been changed  to completed  Successfully",
  "Medication status has been changed  to currentlynottalking  Successfully": "Medication status has been changed  to currentlynottalking  Successfully",
  "Medication status  has been changed  to currentlytalking  Successfully": "Medication status  has been changed  to currentlytalking  Successfully",
  "No records found": "No records found",
  "Patients waiting": "Patients waiting",
  "Patients completed": "Patients completed",
  "Patients in call": "Patients in call",
  "Total Patients": "Total Patients",
  "alternatives suggested": "alternatives suggested",
  "Waiting": "Waiting",
  "Call started": "Call started",
  "Call completed": "Call completed",
  "Consult completed": "Consult completed",
  "Canceled": "Cancelled",
  "Primary": "Primary",
  "FollowUp": "FollowUp",
  "Number of queries must be just a number": "Number of queries must be just a number",
  "You must select at least one medical specialty": "You must select at least one medical specialty",
  "You must enter a value greater than or equal to 1 for the number of queries": "You must enter a value greater than or equal to 1 for the number of queries",
  "The number of consultations is required when selecting the medical specialty." : "The number of consultations is required when selecting the medical specialty.",
  "Venezuelan ID": "Venezuelan ID",
  "Identification document": "Identification document",  
  "Telephone Nro.": "Telephone Nro.",
  "Please fill the required fields in visit summary form": "Please fill the required fields in visit summary form",
  "Please enter description in Paraclinical Prescription": "Please enter description in Paraclinical Prescription",
  "Please enter title in Paraclinical Prescription": "Please enter title in Paraclinical Prescription",
  "Medicine name is required": "Medicine Title is required",
  "Waiting Room": "Waiting Room",
  "Support": "Customer Support",
  "Support field is too long": "Customer Support field is too long",
  "Support is required": "Customer Support is required",
  "Label": "Label",
  "Label field is too long": "Label is too long",
  "Organization details": "Organization details",
  "Label is required": "Label is required",
  "Dimentions should be": "Dimentions should be: ",
  "All": "All",
  "Bank": "Bank",
  "Tradename": "Tradename",
  "Tradename is Required.": "Tradename is required.",
  "Affiliation": "Affiliation",
  "Medical specialties":"Medical specialties",
  "Add Organization": "Add Organization",
  "Organizations": "Organizations",
  "Add new organization": "Add new organization",
  "Add new subsidiary": "Add new subsidiary",
  "Edit subsidiary": "Edit subsidiary",
  "The user has been download the report successfully": "The user has been download the report successfully",
  "Home": "Home",
  "Show": "Show",
  "entries": "entries",
  "of": "of",
  "record(s)": "record(s)",
  "Previous": "Previous",
  "Next": "Next",
  "Copy": "Copy",
  "Excel": "Excel",
  "PDF": "PDF",
  "The user has been copy the table successfully": "The user has been copy the table successfully",
  "Search for organization": "Search for organization",
  "Type": "Type",
  "Business name": "Business name",
  "RIF": "RIF",
  "Administrators": "Administrators",
  "Total members": "Total members",
  "Creation date": "Creation date",
  "Actions": "Actions",
  "Inactive": "Inactive",
  "Pending": "Pending",
  "See detail": "See detail",
  "Add subsidiary": "Add subsidiary",
  "Triage":"Triage",
  "Requires triage":"Requires triage",
  "Remove": "Remove",
  "Organization data": "Organization data",
  "Organization type": "Organization type",
  "Type of specialty": "Type of specialty",
  "Number of queries":"Number of queries",
  "Automatic Renewal":"Automatic Renewal",
  "Monthly":"monthly",
  "Annual": "Annual",
  "Does not apply":"Does not apply",
  "Automatic renewal of consultations by specialty":"Automatic renewal of consultations by specialty",
  "Number of consultations per patient for medical specialties":"Number of consultations per patient for medical specialties",
  "Business": "Business",
  "Required field": "Required field",
  "Obligatory field": "Obligatory field",
  "The RIF must have 9 digits": "The RIF must have 9 digits",
  "The RIF can only have digits": "The RIF can only have digits",
  "The business name must have a maximum of 255 characters": "The business name must have a maximum of 255 characters",
  "Membership name": "Membership name",
  "Parent company": "Parent company",
  "Membership name must have a maximum of 255 characters": "Membership name must have a maximum of 255 characters",
  "Membership name must have a maximum of 50 characters": "Membership name must have a maximum of 50 characters",
  "Admin users": "Admin users",
  "optional": "optional",
  "Add new user": "Add new user",
  "User": "User",
  "Name": "Name",
  "Name must have a maximum of 255 characters": "Name must have a maximum of 255 characters",
  "Last name": "Last name",
  "Last name must have a maximum of 255 characters": "Last name must have a maximum of 255 characters",
  "Identification number": "Identification number",
  "Identification number must have a minimum of 8 characters": "Identification number must have a minimum of 8 characters",
  "Identification number must have a maximum of 10 characters": "Identification number must have a maximum of 10 characters",
  "Email must have a maximum of 255 characters": "Email must have a maximum of 255 characters",
  "The email must be a valid email": "The email must be a valid email",
  "Delete user": "Delete user",
  "You must associate at least one user to this organization": "You must associate at least one user to this organization",
  "Are you sure to change the status of the organization?": "Are you sure to change the status of the organization?",
  "This action will inactivate admin users and their member users will be disaffiliated from membership": "This action will inactivate admin users and their member users will be disaffiliated from membership",
  "Confirm": "Confirm",
  "Are you sure you want to delete the organization?": "Are you sure you want to delete the organization?",
  "It is necessary that the organization has no associated subsidiaries": "It is necessary that the organization has no associated subsidiaries",
  "Unable to delete an active organization": "Unable to delete an active organization",
  "OK understood": "OK understood",
  "Edit organization": "Edit organization",
  "Organization detail": "Organization detail",
  "The organization is already registered": "The organization is already registered",
  "Report - List of Organizations": "Report - List of Organizations",
  "Email is already in use": "Email is already in use",
  "To activate the organization there must be at least one active contact user": "To activate the organization there must be at least one active contact user",
  "Accept": "Accept",
  "Does it require PoweredBy?": "Does it require PoweredBy?",
  "Label must have a maximum of 255 characters": "Label must have a maximum of 255 characters",
  "Customer support": "Customer support",
  "Customer support must have a maximum of 75 characters": "Customer support must have a maximum of 75 characters",
  "Customer support must be an email": "Customer support must be an email",
  "Commercial address": "Commercial address",
  "Commercial address must have a maximum of 255 characters": "Commercial address must have a maximum of 255 characters",
  "*.png, *.jpeg, *.jpg. Max size: 5MB": "*.png, *.jpeg, *.jpg. Max size: 5MB",
  "File not allowed": "File not allowed",
  "logo": "logo",
  "Waiting room": "Waiting room",
  "See list": "See list",
  "The following table shows those organizations to which the Physician pays attention": "The following table shows those organizations to which the Physician pays attention",
  "Deleted": "Deleted",
  "The RIF can only have digits and a hyphen": "The RIF can only have digits and a hyphen",
  "This name is visible to your members": "This name is visible to your members",
  "Do you receive the patients medical report and prescription?": "Do you receive the patient's medical report and prescription?",
  "Users who will receive patient information": "Users who will receive patient information",
  "Add another recipient": "Add another recipient",
  "The indicated emails are the same": "The indicated emails are the same",
  
  
  "Allies,":"Allies",
  "Add ally":"Add ally",
  "Agreement ID":"Agreement ID",
  "New coupon":"New coupon",
  "List of allies":"List of allies",
  "Coupon List":"Coupon List",
  "Coupon ID":"Coupon ID",
  "Total coupons":"Total coupons",
  "Total generated":"Total generated",
  "Total used":"Total used",
  "Valid until":"Valid until",
  "Valid from":"Valid from",
  "Are you sure you want deactivate the coupon?":"Are you sure you want deactivate the coupon?",
  "Are you sure you want eliminate the ally?":"Are you sure you want eliminate the ally?",
  "See ally details":"See ally details",
  "Agreement details":"Agreement details",
  "Category":"Category",
  "Successfully added":"Successfully added",
  "Add new ally":"Add new ally",
  "Edit ally":"Edit ally",
  "See coupon detail":"See coupon detail",
  "Discount":"Discount",
  "Conditions":"Conditions",
  "Reason":"Reason",
  "Add new coupon":"Add new coupon",
  "Edit coupon":"Edit coupon",
  "Find ally":"Find ally",

  
  "Subsidiaries":"Subsidiaries",
  "You must complete the organization details": "You must complete the organization details",

   "Specialty to be treated": "Especialidad a tratar",
  "Specialty to be treated is Required.": "Se requiere especialidad a tratar"
}
